<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- Sheet: content weighted toward vertical center (less empty space above) -->
    <rect
      x="5"
      y="3"
      width="14"
      height="18"
      rx="2"
      fill="none"
      class="stroke"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <!-- Three evenly spaced checklist rows -->
    <path
      d="M7 6.5L8.6 8.1L10.9 6"
      class="stroke"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 7.25H19"
      class="stroke"
      stroke-width="1.2"
      stroke-linecap="round"
    />
    <path
      d="M7 11L8.6 12.6L10.9 10.5"
      class="stroke"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 11.75H18"
      class="stroke"
      stroke-width="1.2"
      stroke-linecap="round"
    />
    <path
      d="M7 15.5L8.6 17.1L10.9 15"
      class="stroke"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 16.25H19"
      class="stroke"
      stroke-width="1.2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PlanClipboardIcon",
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
